import React from "react"

export default function Checkmark() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
         <path fillRule="evenodd" clipRule="evenodd" d="M9.64746 0.475586C4.67946 0.475586 0.647461 4.50759 0.647461 9.47559C0.647461 14.4436 4.67946 18.4756 9.64746 18.4756C14.6155 18.4756 18.6475 14.4436 18.6475 9.47559C18.6475 4.50759 14.6155 0.475586 9.64746 0.475586Z" fill="#705ec9" />
         <path d="M14.0005 7.29182L8.69536 12.5969C8.56605 12.7263 8.39628 12.7912 8.22652 12.7912C8.05675 12.7912 7.88699 12.7263 7.75768 12.5969L5.10511 9.94438C4.84582 9.68509 4.84582 9.26599 5.10511 9.0067C5.3644 8.74741 5.7835 8.74741 6.04279 9.0067L8.22652 11.1904L13.0628 6.35413C13.3221 6.09485 13.7412 6.09485 14.0005 6.35413C14.2598 6.61342 14.2598 7.03253 14.0005 7.29182Z" fill="white" stroke="white" strokeWidth="0.5" />
      </svg>
   )
}
